import React, { Suspense, lazy } from 'react';
import {
  ErrorBoundary, Footer, Header, Loading, Pagesection, PageWrapper,
} from '@ktag/styleguide/dist/react';
import App from './App';

const Stylesheet = lazy(() => import('./Stylesheet'));

// import './app.scss';

interface Props {
  standalone?: boolean;
  graphUrl: string;
  height?: number;
  copyright?: string;
}

function AppWrapper(props: Props) {
  const {
    standalone,
    graphUrl,
    height,
    copyright,
  } = props;

  if (standalone !== true) {
    return (
      <ErrorBoundary>
        <Suspense fallback={<Loading />}>
          <App graphUrl={graphUrl} height={height} copyright={copyright} />
        </Suspense>
      </ErrorBoundary>
    );
  }

  return (
    <Suspense fallback={<div />}>
      <Stylesheet />
      <PageWrapper>
        <Header />
        <PageWrapper.Main>
          <Pagesection type="broad">
            <div className="richtext">
              <Suspense fallback={<Loading />}>
                <App graphUrl={graphUrl} height={height} copyright={copyright} />
              </Suspense>
            </div>
          </Pagesection>
        </PageWrapper.Main>
        <Footer />
      </PageWrapper>
    </Suspense>
  );
}

AppWrapper.defaultProps = {
  standalone: false,
  height: undefined,
  copyright: undefined,
};

export default AppWrapper;
